import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";

export const getAllUnavailability = async () => {
    try {
        const { data } = await Api.get("/api/Unavailability/GetAllUnavailability")
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao consultar todas as Disponibilidades'))
    } 
}